import {dispatchAcknowledgedEvent} from '../../core/resourceEvents';
import {highlightExistingAction} from '../../core/actionHighlighter';
import {openCaptivePortalsSection} from '../ioPass/adapter';
import {
	CAPTIVE_PORTAL_FILTER_EVENT,
	CAPTIVE_PORTAL_FOCUS_EVENT,
	CAPTIVE_PORTAL_REFRESH_EVENT,
} from './events';

/**
 * Open the Captive Portals list.
 *
 * Reuses the IO-Pass adapter rather than repeating it: the accordion is on
 * the Configuration tab, and getting there is the same two steps whether
 * the request was for the list or for a row in it.
 *
 * @return {Promise<void>} completion
 */
export function openCaptivePortalSection() {
	return openCaptivePortalsSection();
}

/**
 * Narrow the Captive Portals table to a search term.
 *
 * An empty term is the box being cleared, which is what Refresh asks for -
 * the same reading `clients.jsx` settled on, and the reason both arrive
 * here rather than as two different commands.
 *
 * @param {object} command filter command
 * @return {Promise<object>} acknowledgement
 */
export function applyCaptivePortalFilter(command) {
	return dispatchAcknowledgedEvent(CAPTIVE_PORTAL_FILTER_EVENT, {
		query: String(command.params?.query || '').trim(),
		resource: 'captive_portal',
	});
}

/**
 * Bring one captive portal's row into view.
 * @param {object} command focus command
 * @return {Promise<object>} acknowledgement
 */
export function focusCaptivePortal(command) {
	return dispatchAcknowledgedEvent(CAPTIVE_PORTAL_FOCUS_EVENT, {
		entityId: String(command.params?.entity_id || ''),
		resource: 'captive_portal',
	});
}

/**
 * Reload the Captive Portals table.
 * @return {Promise<object>} acknowledgement
 */
export function refreshCaptivePortals() {
	return dispatchAcknowledgedEvent(CAPTIVE_PORTAL_REFRESH_EVENT, {});
}

/**
 * Highlight the accordion's bulk Delete control.
 *
 * The agent points at it and stops: selecting which rows to delete, and
 * confirming, is the person's. Open-only ends at the control.
 *
 * @param {object} command experience command
 * @return {Promise<void>} completion
 */
export async function highlightCaptivePortalBulkDelete(command = {}) {
	await openCaptivePortalSection();
	const activation = {
		activate: command.params?.action_activation === 'auto',
		commandId: command.command_id,
	};
	if (!highlightExistingAction(['Delete'], [], activation)) {
		throw new Error('captive_portal_bulk_delete_unavailable');
	}
}
